var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineAddOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4629_8459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3334C14.6018 18.3334 18.3327 14.6026 18.3327 10.0001C18.3327 5.39758 14.6018 1.66675 9.99935 1.66675C5.39685 1.66675 1.66602 5.39758 1.66602 10.0001C1.66602 14.6026 5.39685 18.3334 9.99935 18.3334Z",
    stroke: "#006BFF",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 6.66675V13.3334M6.66602 10.0001H13.3327",
    stroke: "#006BFF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4629_8459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineAddOne);
export default __webpack_public_path__ + "static/media/outline_add-one.beac86e32cb1ed24615367c795eeae83.svg";
export { ForwardRef as ReactComponent };